import React from 'react'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Button,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Tooltip,
  Typography
} from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { withTheme } from "@material-ui/core/styles"
import { actionSaveUser } from "../../actions/UserActions"
import Util, {SUCCESS, ERROR} from "../../common/Util"
import ChipRedimidor from "../../components/ChipRedimidor/ChipRedimidor"
let _handleSubmitFail;

class AssignRolToUser extends React.PureComponent{
  constructor(props){
    super(props)
    this.onSave=this.onSave.bind(this)
    this.renderFieldByRol=this.renderFieldByRol.bind(this)
    this.onChangeRolRedimidorAutocomplete=this.onChangeRolRedimidorAutocomplete.bind(this)
    this.onChangeRolAutocomplete=this.onChangeRolAutocomplete.bind(this)
    this.onDeleteRolRedimidorChip=this.onDeleteRolRedimidorChip.bind(this)
    this.onDeleteRolChip=this.onDeleteRolChip.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)

  }

  componentWillReceiveProps(nextProps){
    if(this.props.user!=nextProps.user){
      let proRolesRedimidor = [] //Se graba en la base cómo objeto y se usa en la pantalla cómo lista
      if(nextProps.user.proRolesRedimidor){
        for(let k in nextProps.user.proRolesRedimidor){
          proRolesRedimidor.push({...nextProps.user.proRolesRedimidor[k], id:k})
        }
      }
      console.log("PRO ROLES REDIMIDOR", proRolesRedimidor, nextProps.user.proRolesRedimidor)
      this.props.initialize({proRoles:[], ...nextProps.user, proRolesRedimidor:proRolesRedimidor})
    }
  }
 
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onSave(formValue){
    let user = {...formValue}
    let proRolesRedimidor = {}
    if(user.proRolesRedimidor){ //Se graba en la base cómo objeto y se usa en la pantalla cómo lista
      for(let i = 0;i<user.proRolesRedimidor.length;i++){
        let pr = user.proRolesRedimidor[i]
        let id = pr.id
        delete pr.id
        console.log("ID", id)
        proRolesRedimidor[id]=pr
      }
      console.log("user.proRolesRedimidor", proRolesRedimidor, user.proRolesRedimidor)
      user.proRolesRedimidor=proRolesRedimidor
      
    }
    this.props.actionSaveUser(
      user, 
      ()=>{
        Util.showNoty(SUCCESS, "Se asignaron los roles correctamente")
        this.props.onClose(SUCCESS)
      },
      (e)=>{
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No se pudieron asignar los roles")
      }
    )
    
  }

  onChangeRolRedimidorAutocomplete(evt, newValue){
    if(newValue){
      const exist = this.props.proRolesRedimidor.some((t)=>{return t.id==newValue.id})
      if(!exist){
        let t = this.props.proRolesRedimidor.slice(0)
        t.push(newValue)
        this.props.change("proRolesRedimidor", t)
      }
    }
  }

  onChangeRolAutocomplete(evt, newValue){
    if(newValue){
      const exist = this.props.roles.some((r)=>{return r.id==newValue.id})
      // console.log("ON CHANGE AutoCOMPLETE", newValue, this.props.roles, exist)
      if(!exist){
        let r = this.props.roles.slice(0)
        r.push(newValue)
        this.props.change("proRoles", r)
      }
    }
  }

  onDeleteRolRedimidorChip(item){
    const nt = this.props.proRolesRedimidor.filter((t)=>{return t.id!=item.id})
    this.props.change("proRolesRedimidor", nt)
  }

  onDeleteRolChip(item){
    const nr = this.props.roles.filter((r)=>{return r.id!=item.id})
    this.props.change("proRoles", nr)
  }

  renderFieldByRol(){
    // console.log("ROL", this.props.roles)
    if(this.props.roles&&this.props.roles.some((r)=>{return r.id=="Redimidor"})){ 
      return (
        <Grid container item xs={12}>
          <InputLabel shrink>Seleccione los roles de redimidor del usuario</InputLabel>
          <Autocomplete
            autoComplete
            options={this.props.rolesRedimidoresList}
            getOptionLabel={option => option.rolName}
            onChange={this.onChangeRolRedimidorAutocomplete}
            renderInput={params => (
              <TextField {...params} fullWidth />
            )}
          />
          <Box className="top10">
            {this.props.proRolesRedimidor.map((item,i)=>{
              return <ChipRedimidor key={`chip${i}`}
                                    rolRedimidor={item}
              // color="primary" 
              //             label={item.rolName}
                          onDelete={()=>{this.onDeleteRolRedimidorChip(item)}} />
            })} 
          </Box>
        </Grid>
      )
    }
    return (<Grid container item xs={12}/>)
  }

  render(){
    const {theme, open, rolList, handleSubmit, onClose} = this.props
    return (
      <Dialog open={open}>
        <DialogTitle>
          <Typography variant="h1" color="primary">Asignar rol a usuario</Typography>
          </DialogTitle>
        <DialogContent style={{minWidth:500}}>
          <form> 
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Field
                  component={TextField}
                  name="proEmail"
                  label="e-mail"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel shrink>Rol</InputLabel>
                <Autocomplete
                  autoComplete
                  options={this.props.rolList}
                  getOptionLabel={option => option.id}
                  onChange={this.onChangeRolAutocomplete}
                  renderInput={params => (
                    <TextField {...params} fullWidth />
                  )}
                />
                <Box className="top10">
                  {this.props.roles&&this.props.roles.map((item,i)=>{
                    return <Chip key={`chip${i}`}
                                color="primary" 
                                label={item.id}
                                onDelete={()=>{this.onDeleteRolChip(item)}} />
                  })} 
                </Box>
              </Grid>
              {this.renderFieldByRol()}
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancelar">
            <Button variant="contained" color="secondary" onClick={onClose}>Cancelar</Button>
          </Tooltip>
          <Tooltip title="Guardar">
            <Button variant="contained" color="primary" onClick={handleSubmit(this.onSave)}>Guardar</Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    rolList: store.rol.rolList,
    rolesRedimidoresList: store.rol.rolesRedimidoresList,
    roles: store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.proRoles,
    proRolesRedimidor: store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.proRolesRedimidor
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveUser
    },
    dispatch
  );
}

export default  reduxForm({
  form: "assignRolToUser",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AssignRolToUser)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/users/AssignRolToUser.js